import { denormalisedResponseEntities } from '../../util/data';

/**
 * Pobiera subskrypcję i denormalizuje ją używając denormalisedResponseEntities
 */
export const fetchSubscription = async (sdk, subscriptionId) => {
  const response = await sdk.newSdk.subscriptions.show({ 
    id: subscriptionId, 
    include: ['listing', 'provider', 'listing.images', 'deliveryToProvider'] 
  });
  
  // denormalisedResponseEntities zwraca tablicę zdenormalizowanych obiektów z 'data'
  const entities = denormalisedResponseEntities(response);
  return entities[0]; // show zawsze zwraca jeden główny obiekt na początku
};

/**
 * Aktualizacja subskrypcji z flagą syncPayment
 */
export const updateSubscriptionPayment = async (sdk, subscriptionId) => {
  const response = await sdk.newSdk.subscriptions.update({
    id: subscriptionId,
    syncPayment: {} 
  });
  
  const entities = denormalisedResponseEntities(response);
  return entities[0];
};